export const useSeoLinks = () => {
  const config = useRuntimeConfig()
  const nuxt = useNuxtApp()
  const { $i18n } = nuxt
  const route = useRoute()

  const { getBaseURL } = useURL()
  const { getNewUrl } = useSetRouteParams()

  const linksAlternate = (domainUrl: string) =>
    $i18n.locales.value
      .map((l) => ({
        key: `alternate-${l.code}`,
        rel: 'alternate',
        href: () => `${domainUrl}${getNewUrl(l.code)}`,
        hreflang: l.code.toString(),
      }))
      .concat({
        key: 'alternate-default',
        rel: 'alternate',
        href: () => `${domainUrl}${getNewUrl('en')}`,
        hreflang: 'x-default',
      })

  const domainUrl = computed(() => getBaseURL())

  const linksCanonicalAndAlternate = computed(() => [
    {
      rel: 'canonical',
      href: () => `${domainUrl.value}${route.path}`,
    },
    ...linksAlternate(domainUrl.value),
  ])

  const linksCanonicalAndAlternatePrivatevillapreview = computed(() => [
    {
      rel: 'canonical',
      href: () => `${config.public.whiteBrandUrl}${route.path}`,
    },
    ...linksAlternate(config.public.whiteBrandUrl),
  ])

  return {
    getNewUrl,
    linksCanonicalAndAlternate,
    linksCanonicalAndAlternatePrivatevillapreview,
  }
}
